// apps/web/src/services/safetyService.js
import { apiRequest } from './api';

const SafetyService = {
    blockUser: (targetId) =>
        apiRequest(`/safety/block/${targetId}`, { method: 'POST' }),

    unblockUser: (targetId) =>
        apiRequest(`/safety/block/${targetId}`, { method: 'DELETE' }),

    getBlockedUsers: () =>
        apiRequest('/safety/blocked'),

    submitReport: ({ reported_user_id, reported_content_id, reported_content_type = 'user', reason, details }) =>
        apiRequest('/safety/report', {
            method: 'POST',
            body: { reported_user_id, reported_content_id, reported_content_type, reason, details },
        }),
};

export default SafetyService;